import React from 'react';
import { LegalShell, Section } from '../../components/legal/LegalShell';

const CancellationPolicy = () => (
  <LegalShell eyebrow="Legal" title="Cancellation Policy" updated="February 2026">
    <p>This Cancellation Policy explains how and when you may cancel your maintenance service plan with Domestic Home Services Limited. It should be read together with our Terms &amp; Conditions and our Refund Policy.</p>
    <p>Nothing in this policy affects your statutory consumer rights.</p>

    <Section n="1" title="14-Day Cooling-Off Period">
      <p>You have a 14-day cooling-off period beginning from the date your plan is confirmed. During this period you may cancel without giving a reason and, provided no service has been requested or provided, any payment received will normally be refunded in full.</p>
    </Section>

    <Section n="2" title="Cancelling After the Cooling-Off Period">
      <p>You may cancel your plan at any time after the 14-day cooling-off period by contacting our customer-service team by telephone on 0113 548 7557 or by email to hello@domestichomeservices.com.</p>
      <p>A cancellation / administration charge may apply. The applicable charge will be advised at the point of cancellation and shown on your Cancellation Invoice.</p>
    </Section>

    <Section n="3" title="Monthly Plans">
      <p>If you are paying monthly, cancellation may take effect at the end of the current billing month, subject to any applicable minimum term as set out in your Terms &amp; Conditions and any cancellation / administration charge that may apply.</p>
    </Section>

    <Section n="4" title="Annual Plans">
      <p>If you are paying annually and cancel after the 14-day cooling-off period, a pro-rata refund may be offered where permitted, less any charges reflecting services already provided under the plan and any applicable cancellation / administration charge.</p>
    </Section>

    <Section n="5" title="Renewals">
      <p>Where a plan renews (for example on an annual basis), we will notify you before renewal. If you do not wish to renew, please contact us before your renewal date on the details in section 6.</p>
    </Section>

    <Section n="6" title="How to Cancel">
      <p><b>Telephone:</b> 0113 548 7557 (Monday to Friday, 9am to 5pm)<br /><b>Email:</b> hello@domestichomeservices.com<br /><b>Post:</b> Domestic Home Services Limited, 128 City Road, London, United Kingdom, EC1V 2NX (Registered Office)</p>
      <p>Please quote your plan number when contacting us so we can process your cancellation as quickly as possible.</p>
    </Section>

    <Section n="7" title="Contact">
      <p>If you have any questions about this Cancellation Policy, please contact our customer-service team using the details above.</p>
    </Section>
  </LegalShell>
);

export default CancellationPolicy;
